function anyAssignedElements(slot) {
  return slot.assignedElements({ flatten: true }).length > 0;
}
function anyNonEmptyTextAssigned(slot) {
  const temp = slot.assignedNodes({ flatten: true }).filter((node) => node.nodeType === 3).filter((node) => node.nodeValue?.trim());
  return temp.length > 0;
}
function checkSlot(slot) {
  slot.classList.toggle(
    "skapa-empty",
    !(anyAssignedElements(slot) || anyNonEmptyTextAssigned(slot))
    // if there are assigned elements or non empty text then its NOT empty.
  );
}
function slotChange(event) {
  const slot = event.target;
  checkSlot(slot);
}
export {
  checkSlot,
  slotChange
};
